<template>
  <div>
    <ValidationObserver ref="observer" v-slot="{ invalid }">
      <v-app-bar flat color="primary">
        <v-spacer></v-spacer>
        <img
          :src="`${publicPath}img/logo-white-small.png`"
          style="max-height: 26px; height: 100%"
        />
        <v-spacer></v-spacer>
      </v-app-bar>
      <template v-if="lineLoading">
        <v-row :align="'center'" justify="center" style="height: 75vh">
          <div class="text-center">
            <v-progress-circular
              :size="70"
              :width="7"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </div>
        </v-row>
      </template>
      <v-container v-else-if="view == 'fillidcard'">
        <div class="text-center">
          <div class="mt-5">กรุณากรอกข้อมูล เพื่อลงทะเบียนใช้บริการ</div>
          <h3>GENERALI LINE CONNECT</h3>
          <div class="mt-6">*เลขบัตรประจำตัวประชาชน / พาสปอร์ต</div>
          <ValidationProvider
            v-if="view == 'fillidcard'"
            name="เลขบัตรประจำตัวประชาชน / พาสปอร์ต"
            :rules="{
              required: true,
              regex: /^[0-9]{13}|(?!^0+$)[a-zA-Z0-9]{3,20}$/,
            }"
            v-slot="{ errors, valid }"
          >
            <v-text-field
              :key="'idcard'"
              name="เลขบัตรประจำตัวประชาชน / พาสปอร์ต"
              ref="idcard"
              v-model="idcard"
              maxlength="13"
              v-mask="'XXXXXXXXXXXXX'"
              label
              prepend-inner-icon="mdi-account-circle-outline"
              outlined
              :error-messages="errors"
              :success="valid"
              :hide-details="errors.length == 0"
            ></v-text-field>
          </ValidationProvider>
          <v-btn
            class="mt-6"
            color="primary"
            :disabled="invalid"
            :loading="loading"
            depressed
            tile
            @click="checkIdCard"
            >ถัดไป</v-btn
          >
        </div>
      </v-container>
      <v-container v-else-if="view == 'applyprovicy'">
        <div v-if="viewpolicy == 1" class="text-center">
          <div class="mt-5">ข้อกำหนดและเงื่อนไขการใช้บริการ</div>
          <h3>GENERALI LINE CONNECT</h3>
          <div class="mt-6">
            <terms-and-conditions1
              :consentdata="consentdata"
            ></terms-and-conditions1>
          </div>
          <div class="mt-3">
            <div class="mt-2 text-center">
              <b>ข้าพเจ้าได้อ่านข้อความข้างต้นและเข้าใจโดยตลอดแล้ว</b>
            </div>
            <v-row justify="space-around">
              <v-checkbox
                v-model="isCheckPrivacy1"
                class="mx-2"
                :label="`ยอมรับข้อกำหนดและเงื่อนไขการใช้บริการ`"
                color="primary"
              ></v-checkbox>
            </v-row>
            <v-btn
              color="primary"
              depressed
              tile
              @click="viewpolicy = 2"
              :disabled="!isCheckPrivacy1"
              >ยืนยัน</v-btn
            >
          </div>
        </div>
        <div v-if="viewpolicy == 2" class="text-center">
          <div class="mt-5">ข้อกำหนดและเงื่อนไขการใช้บริการ</div>
          <h3>GENERALI LINE CONNECT</h3>
          <div class="mt-6">
            <terms-and-conditions2
              :consentdata="consentdata"
            ></terms-and-conditions2>
          </div>
          <div class="mt-3">
            <div class="mt-2 text-center">
              <b>ข้าพเจ้าได้อ่านข้อความข้างต้นและเข้าใจโดยตลอดแล้ว</b>
            </div>
            <div class="pl-10">
              <div>
                <v-checkbox
                  v-model="isCheckPrivacy2.agree"
                  class="mx-2"
                  @change="onChangePrivacy('disagree')"
                  :label="`ยินยอมในการเก็บ ใช้ และเปิดเผยข้อมูลส่วนบุคคล`"
                  color="primary"
                ></v-checkbox>

                <v-checkbox
                  v-model="isCheckPrivacy2.disagree"
                  @change="onChangePrivacy('agree')"
                  class="mx-2 mt-0 pt-0"
                  :label="`ไม่ยินยอม`"
                  color="primary"
                ></v-checkbox>
              </div>
            </div>

            <v-btn
              color="primary"
              depressed
              tile
              :loading="terms1saveloading"
              @click="gotophone"
              :disabled="!isCheckPrivacy2.agree && !isCheckPrivacy2.disagree"
              >ยืนยัน</v-btn
            >
          </div>
        </div>
      </v-container>
      <v-container v-else-if="view == 'fillphone'">
        <div class="text-center">
          <div class="mt-5">กรุณากรอกข้อมูล เพื่อลงทะเบียนใช้บริการ</div>
          <h3>GENERALI LINE CONNECT</h3>
          <div class="mt-6">
            *กรอกเบอร์โทรศัพท์ของคุณที่ให้ไว้กับทางบริษัทเพื่อรับ OTP
          </div>
          <ValidationProvider
            name="เบอร์โทรศัพท์"
            :rules="{ required: true, regex: /^[0][3-9]-[0-9]{4}-[0-9]{4}$/ }"
            v-slot="{ errors, valid }"
          >
            <v-text-field
              name="เบอร์โทรศัพท์"
              :key="'phone'"
              ref="mobilephone"
              v-model="phone"
              v-mask="'##-####-####'"
              label
              type="tel"
              prepend-inner-icon="mdi-cellphone-android"
              outlined
              placeholder="XX-XXXX-XXXX"
              :error-messages="errors"
              :success="valid"
              :hide-details="errors.length == 0"
            ></v-text-field>
          </ValidationProvider>
          <div class="caption mt-2">คุณจะได้รับรหัส OTP 6 หลัก ผ่านทาง SMS</div>
          <v-btn
            class="mt-6"
            color="primary"
            :disabled="invalid"
            depressed
            tile
            :loading="loading"
            @click="checkPhone"
            >ขอรหัส OTP</v-btn
          >
        </div>
      </v-container>
      <v-container v-else-if="view == 'fillotp'">
        <div class="text-center">
          <div class="mt-5">กรุณากรอกข้อมูล เพื่อลงทะเบียนใช้บริการ</div>
          <h3>GENERALI LINE CONNECT</h3>
          <div class="mt-6">
            กรอกรหัส 6 หลัก ที่คุณได้รับทาง SMS ที่เบอร์ {{ censorPhone }}
            {{ otp_detail ? `(REF: ${otp_detail.ref})` : "" }}
          </div>
          <div style="max-width: 375px; margin: auto">
            <ValidationProvider
              name="รหัส OTP"
              :rules="{ required: true, length: 6 }"
              v-slot="{ errors, valid }"
            >
              <v-text-field
                ref="inputotp"
                v-model="fullotp"
                type="tel"
                v-mask="'######'"
                class="input-otp text-center"
                autocomplete="one-time-code"
                label
                outlined
                :error-messages="errors"
                :success="valid"
                :hide-details="errors.length == 0"
              ></v-text-field>
            </ValidationProvider>
          </div>
          <div class="caption mt-2">
            ไม่ได้รับ SMS?
            <a @click="retryOtp">ส่งรหัส OTP อีกครั้ง</a>
          </div>
          <v-btn
            class="mt-6"
            color="primary"
            :loading="loading"
            :disabled="invalid"
            depressed
            tile
            @click="verifyOtp"
            >ยืนยัน</v-btn
          >
        </div>
      </v-container>
      <template v-else-if="view == 'finish'">
        <v-row :align="'center'" justify="center" style="height: 75vh">
          <div class="text-center">
            <v-icon x-large style="font-size: 130px" color="success"
              >mdi-check-circle</v-icon
            >
            <div>คุณเชื่อมต่อบริการ</div>
            <h3>GENERALI LINE CONNECT</h3>
            <div>เรียบร้อยแล้ว</div>
            <v-btn
              class="mt-6"
              color="primary"
              depressed
              tile
              @click="finishRegister"
              >ปิด</v-btn
            >
          </div>
        </v-row>
      </template>
      <template v-else-if="view == 'camera'">
        <div style="width: 100%; max-width: 1024px; margin: auto">
          <iframe
            src="https://generali.zwiz.ai/camera"
            allow="camera;microphone"
          ></iframe>
          <camera></camera>
        </div>
      </template>
      <template v-else-if="view == 'registered'">
        <div class="text-center mt-8">
          <p>
            ท่านได้ทำการลงทะเบียน
            <br />GENERALI LINE CONNECT เรียบร้อยแล้ว
          </p>
          <div>
            หากท่านต้องการยกเลิก
            <br />ใช้บริการ GENERALI LINE CONNECT
          </div>
          <p>กรุณาคลิกปุ่ม "ยกเลิกลงทะเบียน"</p>
        </div>
        <div class="text-center mt-9">
          <v-btn @click="logout" color="primary">ยกเลิกลงทะเบียน</v-btn>
        </div>
      </template>
      <template v-else-if="view == 'covidstep1'">
        <div style="text-align: center">
          <v-img
            width="100%"
            style="margin: auto"
            src="../assets/1024x1024-01.png"
          ></v-img>
        </div>
        <v-container class="px-8">
          <div class="mt-9">
            <p>
              สำหรับลูกค้าเจนเนอราลี่
              <br />สามารถ “ยืนยัน”
              รับสิทธิ์ขยายระยะเวลาความคุ้มครองไวรัสโคโรน่า 2019 (COVID-19)
              เพิ่มเติม <br />เริ่มคุ้มครองตั้งแต่วันที่ 1 พ.ค. – 30 มิ.ย. 63
            </p>
          </div>
          <div class="text-center mt-9">
            <v-btn
              :disabled="!userprofile"
              :loading="covidcheckloading"
              @click="verifyIdcardCovid"
              color="primary"
              >ยืนยัน</v-btn
            >
          </div>
        </v-container>
      </template>
      <v-container v-else-if="view == 'covidstep2'">
        <div class="text-center">
          <h4 class="mt-5">ยืนยันรับสิทธิ์คุ้มครอง COVID-19</h4>
          <v-row class="pl-6 mt-5">
            <v-col cols="6" class="pb-0 text-left">
              <div>ผู้เอาประกัน</div>
            </v-col>
            <v-col cols="6" class="pb-0">
              <div>
                {{ userprofile.first_name }} {{ userprofile.last_name }}
              </div>
            </v-col>
            <v-col cols="6" class="pt-0 text-left">
              <div>หมายเลขบัตรประชาชน</div>
            </v-col>
            <v-col cols="6" class="pt-0">
              <div>{{ userprofile.idcard | markupIdcard }}</div>
            </v-col>
          </v-row>
          <div class="mt-3" style="text-decoration: underline">
            ข้อกำหนดและเงื่อนไข
          </div>
          <div class="mt-6">
            <terms-and-conditions-covid></terms-and-conditions-covid>
          </div>
          <div class="mt-3">
            <v-row justify="space-around">
              <v-checkbox
                v-model="isCheckPrivacy"
                class="mx-2"
                :label="`ยอมรับข้อกำหนดและเงื่อนไข`"
                color="primary"
              ></v-checkbox>
            </v-row>
            <v-btn color="primary" depressed tile @click="view = 'covidstep1'"
              >ยกเลิก</v-btn
            >
            <span class="mx-3"></span>
            <v-btn
              color="primary"
              depressed
              tile
              @click="covidRegister"
              :disabled="!isCheckPrivacy"
              >ยืนยัน</v-btn
            >
          </div>
        </div>
      </v-container>
      <v-container v-if="view == 'covidstep3'">
        <div class="text-center mt-9">
          <div style="text-align: center">
            <v-icon
              color="success"
              style="font-size: 94px; margin-bottom: 0.3em"
              >mdi-emoticon-happy-outline</v-icon
            >
          </div>
          <div>คุณได้ทำการลงทะเบียนเรียบร้อยแล้ว</div>
          <div class="mt-9">
            <v-btn color="primary" depressed tile @click="finishRegister"
              >ปิด</v-btn
            >
          </div>
        </div>
      </v-container>
    </ValidationObserver>

    <v-dialog v-model="showNotFoundIdCard" max-width="600">
      <v-card>
        <v-card-title>
          <h3>ขออภัยค่ะ!</h3>
        </v-card-title>
        <v-card-text>
          <p>
            ไม่พบหมายเลขบัตรประชาชน /
            พาสปอร์ตของท่านในระบบเนื่องจากบริการนี้สงวนสิทธิ์เฉพาะลูกค้า
            <span class="nobr">บริษัทเจนเนอราลี่</span>เท่านั้น
          </p>
          <p>
            หากต้องการข้อมูลเพิ่มเติม กรุณาติดต่อลูกค้าสัมพันธ์ ที่ Line :
            <a
              href="https://line.me/ti/p/@generalithailand"
              target="_blank"
              rel="noopener noreferrer"
              >@GeneraliThailand</a
            >
            พิมพ์ "ติดต่อเจ้าหน้าที่"
          </p>
          <div class="text-center">
            <v-btn
              color="primary"
              depressed
              tile
              @click="showNotFoundIdCard = false"
              >ปิด</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showNotFoundPhone" max-width="600">
      <v-card>
        <v-card-title>
          <h3 style="width: 100%; text-align: center">
            ไม่พบข้อมูลของท่านในระบบ
            <br />กรุณาตรวจสอบอีกครั้ง
          </h3>
        </v-card-title>
        <v-card-text>
          <p class="mt-4">
            หากต้องการข้อมูลเพิ่มเติม กรุณาติดต่อลูกค้าสัมพันธ์ ที่ Line :
            <a
              href="https://line.me/ti/p/@generalithailand"
              target="_blank"
              rel="noopener noreferrer"
              >Generali Thailand</a
            >
            พิมพ์ "ติดต่อเจ้าหน้าที่"
          </p>
          <v-col class="text-center pa-1">
            <v-btn
              style="width: 50%"
              class="ma-0"
              color="primary"
              depressed
              tile
              @click="showNotFoundPhone = false"
              >ปิด</v-btn
            >
          </v-col>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showNotSpam" max-width="600">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <p style="font-size: 1.3em">
            <b
              >คุณทำรายการผิดเกินจำนวนครั้งที่กำหนด
              กรุณาทำการลงทะเบียนใหม่อีกครั้ง</b
            >
            <br />
            {{ errorSpam }}
          </p>
          <p class="mt-4">
            หากต้องการข้อมูลเพิ่มเติม กรุณาติดต่อลูกค้าสัมพันธ์ ที่ Line :
            <a
              href="https://line.me/ti/p/@generalithailand"
              target="_blank"
              rel="noopener noreferrer"
              >Generali Thailand</a
            >
            พิมพ์ "ติดต่อเจ้าหน้าที่"
          </p>
          <v-col class="text-center pa-1">
            <v-btn
              style="width: 50%"
              class="ma-0"
              color="primary"
              depressed
              tile
              @click="showNotSpam = false"
              >ปิด</v-btn
            >
          </v-col>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mask } from "vue-the-mask";
import Camera from "./Camera";

import TermsAndConditions1 from "./TermsAndConditions1";

import TermsAndConditions2 from "./TermsAndConditions2";
import TermsAndConditionsCovid from "./TermsAndConditionsCovid";
export default {
  directives: {
    mask,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    Camera,
    TermsAndConditions1,
    TermsAndConditions2,
    TermsAndConditionsCovid,
  },
  data() {
    return {
      consentdata: "",
      terms1version: "",
      terms2version: "",
      userprofile: "",
      viewpolicy: 1,
      covidcheckloading: false,
      publicPath: process.env.BASE_URL,
      // view: "applyprovicy",
      view: "fillidcard",
      lineLoading: false,
      terms1saveloading: false,
      isCheckPrivacy: false,
      isCheckPrivacy1: false,
      isCheckPrivacy2: {
        agree: false,
        disagree: false,
      },
      otp: [null, null, null, null, null, null],
      userid: null,
      idcard: null, // 1749900335629
      phone: null, // 0830059307
      fullotp: null,
      showNotFoundIdCard: false,
      showNotFoundPhone: false,
      showNotSpam: false,
      video: null,
      loading: false,
      otp_detail: null,
      userId: null,
      sessiontoken: "",
      errorSpam: "",
    };
  },
  computed: {
    serverUrl() {
      return this.$store.state.serverUrl;
    },
    censorPhone() {
      return this.phone && this.phone.length == 12
        ? "XX-XXXX-" + this.phone.split("-")[2]
        : "XX-XXXX-XXXX";
    },
    query() {
      return this.$store.state.query;
    },
    pageid() {
      return this.$store.state.query.pageid;
    },
  },
  created() {
    // document.title = "ลงทะเบียนใช้บริการ GENERALI LINE CONNECT";
  },
  async mounted() {
    if (this.query.state) {
      document.title = "ลงทะเบียนรับสิทธิ์ความคุ้มครองไวรัสโควิด-19 (COVID-19)";
    } else {
      document.title = "ลงทะเบียนใช้บริการ GENERALI LINE CONNECT";
    }
    /* eslint-disable no-console */
    /* eslint-disable no-unused-vars */

    var vm = this;

    vm.userId = vm.$store.state.profile.userId;
    vm.checklineid(false);
    if (vm.query.state == "covidregistercomplete") {
      vm.view = "covidstep1";
    }
    vm.$nextTick(() => {
      vm.$refs.idcard.focus();
    });
    this.terms2version = await this.fetchData();
    /* eslint-enable no-unused-vars */
    /* eslint-enable no-console */
  },
  methods: {
    onChangePrivacy(type) {
      this.isCheckPrivacy2[type] = false;
    },
    async verifyIdcardCovid() {
      var vm = this;
      vm.covidcheckloading = true;
      var data = {
        idcard: vm.userprofile.idcard,
        userid: vm.userId,
      };
      const serverToken = this.$store.state.serverToken;
      const apiToken = this.$store.state.apiToken;
      axios.defaults.headers.common = {
        AUTHORIZATION: `BEARER ${vm.userId} ${apiToken}`,
        apikey: serverToken,
        "x-api-key": this.$store.state.serverApiKey,
      };
      var response = await axios.post(`${vm.serverUrl}verifyidcardcovid`, data);
      if (response.data.responsecode == 200) {
        this.checklineid(true);
      } else {
        this.$swal
          .fire({
            confirmButtonColor: "#c5281d",
            confirmButtonText: "ปิด",
            html: `<div style="text-align:center">ขออภัยค่ะ</div>เนื่องจากกรมธรรม์ของคุณไม่อยู่ในเงื่อนไข สำหรับการลงทะเบียนรับสิทธิ์
                  ขยายเวลาความคุ้มครองไวรัสโคโรนา (COVID-19)  คุณสามารถตรวจสอบเงื่อนไขเพิ่มเติมได้<a href="https://generali.co.th/free-covid-19-phase2/">ที่นี่</a>`,
          })
          .then(() => {
            vm.closewin();
          });
      }
    },
    covidRegister() {
      const apiToken = this.$store.state.apiToken;
      const serverToken = this.$store.state.serverToken;

      axios.defaults.headers.common = {
        AUTHORIZATION: `BEARER ${this.userId} ${apiToken}`,
        apikey: serverToken,
      };

      axios
        .post(this.serverUrl + "registercovid19", {
          ...this.userprofile,
          userid: this.userId,
        })
        .then((response) => {
          if (response.data.responsecode == 200) this.view = "covidstep3";
        });
    },
    logout() {
      let vm = this;
      this.$swal
        .fire({
          text: "ต้องการยกเลิกใช้บริการหรือไม่?",
          showCancelButton: true,
          confirmButtonColor: "#c5281d",
          cancelButtonColor: "#aaa",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
        })
        .then((result) => {
          if (result.value) {
            const apiToken = this.$store.state.apiToken;
            const serverToken = this.$store.state.serverToken;

            axios.defaults.headers.common = {
              AUTHORIZATION: `BEARER ${vm.userId} ${apiToken}`,
              apikey: serverToken,
              "x-api-key": this.$store.state.serverApiKey,
            };
            axios.post(vm.serverUrl + "disconnectlineid").then((response) => {
              if (response.data.responsecode == 200) {
                this.$swal
                  .fire({
                    text: "ท่านได้ยกเลิกใช้บริการเรียบร้อยแล้ว",
                    showCancelButton: false,
                    confirmButtonColor: "#c5281d",
                    // cancelButtonColor: "#aaa",
                    confirmButtonText: "ปิด",
                  })
                  .then(() => {
                    vm.$liff.closeWindow();
                  });
              }
            });
          }
        });
    },
    closewin() {
      this.$liff.closeWindow();
    },
    checklineid(covid) {
      var vm = this;

      const apiToken = this.$store.state.apiToken;
      const serverToken = this.$store.state.serverToken;

      axios.defaults.headers.common = {
        AUTHORIZATION: `BEARER ${this.userId} ${apiToken}`,
        apikey: serverToken,
        "x-api-key": this.$store.state.serverApiKey,
      };

      try {
        var url;
        if (covid) {
          url = "checklineidcovid";
        } else {
          url = "checklineid";
        }
        axios
          .post(this.serverUrl + url, {
            lineid: vm.userId,
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              vm.userprofile = response.data.data[0];
              if (covid) {
                await vm.$swal.fire({
                  icon: "error",
                  confirmButtonColor: "#c5281d",
                  text: "คุณมีสิทธิ์คุ้มครอง Covid-19 อยู่แล้ว",
                });
                vm.closewin();
              } else if (!vm.query.state) {
                // this.registered = true;
                vm.view = "registered";
              }
              vm.lineLoading = false;
            } else {
              if (covid) {
                vm.covidcheckloading = false;
                vm.view = "covidstep2";
              } else {
                // this.registered = false;
                vm.lineLoading = false;
              }
            }
          });
      } catch (err) {
        alert(JSON.stringify(err));
      }
    },
    fetchData() {
      return new Promise((resolve) => {
        var fullUrl = window.location.origin;
        axios.get(fullUrl + "/Consent2.json").then((response) => {
          try {
            var data = response.data;
          } catch (error) {
            alert("รูปแบบข้อมูล Consent ไม่ถูกต้อง ");
          }
          var lastindex = data.length - 1;
          resolve(data[lastindex].versionid);
        });
      });
    },

    async checkIdCard() {
      var vm = this;
      var data = {
        idcard: this.idcard,
        userid: this.userId,
      };
      this.loading = true;
      const apiToken = this.$store.state.apiToken;
      const serverToken = this.$store.state.serverToken;

      axios.defaults.headers.common = {
        AUTHORIZATION: `BEARER ${this.userId} ${apiToken}`,
        apikey: serverToken,
        "x-api-key": this.$store.state.serverApiKey,
      };

      var response = await axios.post(`${this.serverUrl}verifyidcard`, data);

      if (response.data.responsecode == 400) {
        var spamidcard = {
          count: 0,
          time: moment(),
        };
        if (localStorage.getItem("spamidcard")) {
          spamidcard = JSON.parse(localStorage.getItem("spamidcard"));
          if (
            spamidcard.count >= 4 &&
            moment(spamidcard.time).diff(moment(), "minute") < 1
          ) {
            localStorage.removeItem("spamidcard");
            vm.loading = false;
            return;
          } else if (spamidcard.count >= 4) {
            vm.errorSpam = moment(spamidcard.time).format(
              "เวลา HH:mm วันที่ DD/MM/YYYY"
            );
            vm.showNotSpam = true;
            vm.loading = false;
            return;
          }
        }
        spamidcard = {
          count: spamidcard.count + 1,
          time: moment().add(15, "minute"),
        };
        localStorage.setItem("spamidcard", JSON.stringify(spamidcard));
      }

      if (response.data.responsecode == 200) {
        this.sessiontoken = response.data.sessiontoken;
        await this.getLastActiveConsent();
        await this.checkProvicy();
      } else {
        this.showNotFoundIdCard = true;
      }
      this.loading = false;
    },
    getLastActiveConsent() {
      axios.defaults.headers.common = {
        "x-api-key": this.$store.state.serverApiKey,
        apikey: this.$store.state.serverToken,
        AUTHORIZATION: `BEARER ${this.userId} ${this.sessiontoken}`,
      };
      return new Promise((resolve) => {
        axios
          .get(this.$store.state.serverUrl + "consentlastactive", {
            params: {
              userid: this.$store.state.profile.userId,
            },
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              this.consentdata = response.data.result[0];
            } else {
              if (response.data.responsecode == 400) {
                this.$liff.closeWindow();
              } else {
                await this.$swal.fire({
                  text: response.data.reason,
                });
              }
            }
            resolve();
          });
      });
    },
    checkProvicy() {
      return new Promise((resolve) => {
        const serverToken = this.$store.state.serverToken;

        axios.defaults.headers.common = {
          AUTHORIZATION: `BEARER ${this.userId} ${this.sessiontoken}`,
          apikey: serverToken,
          "x-api-key": this.$store.state.serverApiKey,
        };

        axios
          .get(`${this.serverUrl}checkacceptconsent`, {
            params: {
              userid: this.userId, // lineid ไม่ต้องต่อ pageid
              card_number: this.idcard,
              version: this.consentdata.id,
            },
          })
          .then((response) => {
            this.loading = false;
            if (response.data.responsecode == 200) {
              this.$nextTick(() => {
                this.view = "fillphone";
              });
              resolve();
            } else if (response.data.responsecode == 400) {
              this.view = "applyprovicy";
              resolve();
            }
          });
      });
    },
    async checkPhone() {
      var data = {
        idcard: this.idcard,
        mobileno: this.phone.split("-").join(""),
      };
      this.loading = true;
      const serverToken = this.$store.state.serverToken;
      axios.defaults.headers.common = {
        AUTHORIZATION: `BEARER ${this.userId} ${this.sessiontoken}`,
        apikey: serverToken,
        "x-api-key": this.$store.state.serverApiKey,
      };
      var response = await axios.post(
        `${this.serverUrl}verifyidcard_mobile`,
        data
      );
      if (response.data.responsecode == 200) {
        this.sessiontoken = response.data.sessiontoken;
        var response_sendotp = await this.sendOtp();
        if (response_sendotp) {
          this.otp_detail = response_sendotp;
          await this.$swal.fire({
            icon: "success",
            confirmButtonColor: "#c5281d",
            title: "รหัส OTP ได้ถูกส่งไปทาง SMS ที่เบอร์ของคุณเรียบร้อยแล้ว",
          });
          this.view = "fillotp";
          this.$nextTick(() => {
            this.$refs.inputotp.focus();
          });
        } else {
          this.$swal({
            icon: "error",
            confirmButtonColor: "#c5281d",
            title: "ไม่สามารถส่ง SMS ไปที่เบอร์ได้",
          });
        }
      } else if (response.data.responsecode == 401) {
        this.errorSpam = moment(response.data.unlocktimestamp).format(
          "เวลา HH:mm วันที่ DD/MM/YYYY"
        );
        this.showNotSpam = true;
      } else {
        this.showNotFoundPhone = true;
      }
      this.loading = false;
    },
    async retryOtp() {
      this.loading = true;
      var response = await this.sendOtp();
      if (response) {
        this.otp_detail = response;
        await this.$swal.fire({
          icon: "success",
          confirmButtonColor: "#c5281d",
          title: "รหัส OTP ได้ถูกส่งไปทาง SMS ที่เบอร์ของคุณเรียบร้อยแล้ว",
        });
        this.view = "fillotp";
      } else {
        this.$swal({
          type: "error",
          confirmButtonColor: "#c5281d",
          title: "ไม่สามารถส่ง SMS ไปที่เบอร์ได้",
        });
      }
      this.loading = true;
    },
    async sendOtp() {
      var data = {
        mobileno: this.phone.split("-").join(""),
      };
      const serverToken = this.$store.state.serverToken;
      axios.defaults.headers.common = {
        AUTHORIZATION: `BEARER ${this.userId} ${this.sessiontoken}`,
        apikey: serverToken,
        "x-api-key": this.$store.state.serverApiKey,
      };
      var response = await axios.post(`${this.serverUrl}sendotp_mobile`, data);
      if (response.data.responsecode == 200) {
        if (response.data.data && response.data.data.status == "OK") {
          return response.data.data;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    async verifyOtp() {
      var vm = this;
      if (!this.otp_detail) {
        return false;
      }
      var data = {
        otp: this.fullotp,
        mobileno: this.phone.split("-").join(""),
        ref: this.otp_detail.ref,
        transid: this.otp_detail.transid,
      };
      this.loading = true;
      const serverToken = this.$store.state.serverToken;
      axios.defaults.headers.common = {
        AUTHORIZATION: `BEARER ${this.userId} ${this.sessiontoken}`,
        apikey: serverToken,
        "x-api-key": this.$store.state.serverApiKey,
      };
      var response = await axios.post(
        `${this.serverUrl}verifyotp_mobile`,
        data
      );
      if (response.data.responsecode == 400) {
        var spamidcard = {
          count: 0,
          time: moment(),
        };
        if (localStorage.getItem("spamidcard")) {
          spamidcard = JSON.parse(localStorage.getItem("spamidcard"));
          if (
            spamidcard.count >= 4 &&
            moment(spamidcard.time).diff(moment(), "minute") < 1
          ) {
            localStorage.removeItem("spamidcard");
            vm.loading = false;
            return;
          } else if (spamidcard.count >= 4) {
            vm.errorSpam = moment(spamidcard.time).format(
              "เวลา HH:mm วันที่ YYYY/MM/DD"
            );
            vm.showNotSpam = true;
            vm.loading = false;
            return;
          }
        }
        spamidcard = {
          count: spamidcard.count + 1,
          time: moment().add(15, "minute"),
        };
        localStorage.setItem("spamidcard", JSON.stringify(spamidcard));
      }
      if (response.data.responsecode == 200) {
        var updateUserid_response = await this.updateLineId();
        const serverToken = this.$store.state.serverToken;
        const apiToken = this.$store.state.apiToken;
        var responseline = await axios.post(
          this.serverUrl + "checklineid",
          {
            lineid: vm.userId,
          },
          {
            headers: {
              AUTHORIZATION: `BEARER ${this.userId} ${apiToken}`,
              apikey: serverToken,
              "x-api-key": this.$store.state.serverApiKey,
            },
          }
        );
        if (responseline.data.responsecode == 200) {
          vm.userprofile = responseline.data.data[0];
        }

        if (this.query.state && this.query.state == "covidregister") {
          vm.view = "covidstep1";
        } else if (updateUserid_response) {
          this.view = "finish";
        } else {
          await this.$swal.fire({
            icon: "error",
            confirmButtonColor: "#c5281d",
            title: "ระบบเกิดปัญหาขัดข้อง",
          });
        }
      } else {
        await this.$swal.fire({
          icon: "error",
          title: "รหัส OTP ของคุณไม่ถูกต้อง",
          confirmButtonColor: "#c5281d",
        });
      }
      this.loading = false;
    },
    async finishRegister() {
      /* eslint-disable no-undef */
      var message;
      if (this.query.state) {
        message = "Register COVID-19 Complete";
      } else {
        message = "Tax Certificate";
      }
      try {
        await liff.sendMessages([
          {
            type: "text",
            text: message,
          },
        ]);
        liff.closeWindow();
      } catch (error) {
        alert(JSON.stringify(error));
      }
    },
    async updateLineId() {
      var data = {
        idcard: this.idcard,
        mobileno: this.phone.split("-").join(""),
        userid: this.userId,
      };
      const serverToken = this.$store.state.serverToken;
      axios.defaults.headers.common = {
        AUTHORIZATION: `BEARER ${this.userId} ${this.sessiontoken}`,
        apikey: serverToken,
        "x-api-key": this.$store.state.serverApiKey,
      };
      var response = await axios.post(`${this.serverUrl}update_lineid`, data);
      this.sessiontoken = response.data.sessiontoken;
      return response.data.responsecode == 200;
    },
    onKeyupOtp(index, event) {
      /* eslint-disable no-console */
      var key = parseInt(event.key);
      // console.log(event, event.key, Number.isNaN(key));
      if (Number.isNaN(key)) {
        return false;
      }
      if (this.$refs[`input-otp-${index}`]) {
        this.$refs[`input-otp-${index}`].focus();
        this.$set(this.otp, index - 1, null);
      }
      /* eslint-enable no-console */
    },
    gotophone() {
      // SAVE AGREE & DISAGREE INPUT
      this.terms1saveloading = true;
      const serverToken = this.$store.state.serverToken;
      axios.defaults.headers.common = {
        AUTHORIZATION: `BEARER ${this.userId} ${this.sessiontoken}`,
        apikey: serverToken,
        "x-api-key": this.$store.state.serverApiKey,
      };
      var data = {
        userid: this.userId, // ไม่ต้องต่อ pageid
        card_number: this.idcard,
        version: this.consentdata.id,
        isagree: this.isCheckPrivacy2.agree ? true : false,
      };
      axios
        .post(`${this.serverUrl}registerconsent`, data)
        .then(async (response) => {
          this.terms1saveloading = false;
          if (response.data.responsecode == 200) {
            this.view = "fillphone";
            this.$nextTick(() => {
              this.$refs.mobilephone.focus();
            });
          } else {
            await this.$swal.fire({
              text: response.data.reason,
            });
          }
        });
    },
  },
  filters: {
    dateFilter(val) {
      return moment(val).format("HH:mm DD/MM/YYYY");
    },
    markupIdcard(x) {
      if (x) {
        return x.replace(/\d{9}/g, "xxxxxxxxx");
      } else {
        return "";
      }
    },
  },
  watch: {
    otp(newVal) {
      this.fullotp = newVal.join("");
    },
  },
};
</script>

<style lang="scss" scoped></style>

<style lang="scss">
.input-otp {
  input {
    text-align: center;
    // font-size: 26px;
  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
span.nobr {
  white-space: nowrap;
}
</style>
